import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import EasyTyper from "@assets/js/easyTyper";
export default {
  name: "index-guide",
  computed: {
    ...walletVuex.mapState(["deviceType"]),
    ...userVuex.mapState(["isLogin"])
  },
  data() {
    const iconsList = [{
      icon: "icon-lucky",
      name: "LUCKY",
      path: "/lucky"
    }, {
      icon: "icon-fan",
      name: "FAN RIGHTS",
      path: "/fan"
    }, {
      icon: "icon-task",
      name: "TASKS",
      path: "/task"
    }, {
      icon: "icon-vip",
      name: "VIP",
      path: "/vip"
    }, {
      icon: "icon-biography",
      name: "BIOGRAPHY",
      path: "/biography"
    }, {
      icon: "icon-tokenomics",
      name: "TOKENOMICS",
      path: "/"
    }];
    return {
      iconsList,
      guideEasyTyperConfig: {
        output: "",
        // 输出内容  使用MVVM框架时可以直接使用
        type: "rollback",
        isEnd: false,
        speed: 30,
        backSpeed: 40,
        sleep: 3000,
        singleBack: true,
        sentencePause: true
      },
      guideInfo: [{
        content: "Ciao! How’s your day going?"
      }, {
        content: "Ever tried playing as a defender?"
      }, {
        content: "Who inspires you in life or football?"
      }, {
        content: "Which Milan match made you a fan?"
      }, {
        content: "Do you remember my final match at San Siro?"
      }, {
        content: "Tell me—1994 or 2003? Which team looked stronger?"
      }, {
        content: "I wore the No. 3 jersey with pride. What’s your lucky number?"
      }, {
        content: "Want to hear a story from my playing days?"
      }, {
        content: "I’ve played over 900 games. Ask me anything."
      }].map((item, i) => ({
        ...item,
        _uid: i + "-" + Date.now()
      })),
      currentIndex: -1,
      visibleMessages: [],
      loopTimer: null,
      easyTyper: null,
      shuffledGuideInfo: []
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        this.shuffleGuideInfo();
        this.startMessageLoop();
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval(this.loopTimer);
  },
  methods: {
    shuffleGuideInfo() {
      const list = this.guideInfo.slice();
      for (let i = list.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [list[i], list[j]] = [list[j], list[i]];
      }
      // 重新赋 uid 确保唯一性
      this.shuffledGuideInfo = list.map((item, i) => ({
        ...item,
        _uid: i + "-" + Date.now()
      }));
    },
    onTab(index) {
      // 自定义 tab 切换逻辑
      this.$parent.isGuideTab = 1;
      this.$parent.isTab = index;
    },
    startMessageLoop() {
      const showNextMessage = () => {
        let nextIndex;
        do {
          nextIndex = Math.floor(Math.random() * this.shuffledGuideInfo.length);
        } while (nextIndex === this.currentIndex && this.shuffledGuideInfo.length > 1);
        this.currentIndex = nextIndex;
        const message = this.shuffledGuideInfo[this.currentIndex];
        this.visibleMessages = [message];
        this.easyTyper = new EasyTyper(this.guideEasyTyperConfig, [message.content], () => {
          this.easyTyper = null;
          clearTimeout(this.loopTimer);
          loopFnc();
        }, output => {
          this.visibleMessages[0].content = `${output}`;
        });
      };
      const loopFnc = () => {
        this.loopTimer = setTimeout(() => {
          showNextMessage();
        }, 10000); // 10 秒一条
      };

      showNextMessage();
    }
  }
};